module.exports = __webpack_public_path__ + "static/floor-plan-1-140cb53bff6bdabf4de51876ad258960.jpg";